import { getAssetPath } from './configs';

export const TOAST_DURATION = 3000;

const PRELOAD_IMAGE_PATHS = [
  '/bg-register.png',
  '/bg-time-desktop.png',
  '/bg-welcome-sm.svg',
  '/fg-register.png',
  '/logo-with-text.svg',
  '/logo-with-text-vertical.svg',
  '/logo-with-text-white.svg',
  '/cayman-logo.svg',
  '/logo-with-text-vertical-white.svg',
  '/phone-login-en.png',
  '/phone-login-nl.png',
  '/phone-verify-en.png',
  '/phone-verify-nl.png',
  '/phone-input-en.png',
  '/phone-input-nl.png',
  '/protected.png',
  '/phone-question-dual-citizenship.png',
  '/phone-question-us-indicia.png',
  '/question-dual-citizenship.svg',
  '/question-us-indicia.svg',
  '/approved.png',
  '/dual-citizenship/question-dual-citizenship-aia.svg',
  '/dual-citizenship/question-dual-citizenship-brb.svg',
  '/dual-citizenship/question-dual-citizenship-bvi.svg',
  '/dual-citizenship/question-dual-citizenship-dma.svg',
  '/dual-citizenship/question-dual-citizenship-grd.svg',
  '/dual-citizenship/question-dual-citizenship-kna.svg',
  '/dual-citizenship/question-dual-citizenship-lca.svg',
  '/dual-citizenship/question-dual-citizenship-sxm.svg',
  '/dual-citizenship/question-dual-citizenship-vct.svg',
];

export const IMAGES_TO_BE_PRELOAD = PRELOAD_IMAGE_PATHS.map(getAssetPath);
